module.exports = __webpack_public_path__ + "img/zixuncode-lss.f7fa8369.png";